module.exports = __webpack_public_path__ + "img/test11.d668d036.png";